import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { client, urlFor } from "../../sanityClient";
import usePageMeta from "../../hooks/usePageMeta"; // 1. Import hook
import "./BlogPage.css";

function BlogPage() {
  // 2. Set page title and description
  usePageMeta(
    "Blog | TjWit Media",
    "The official blog of TjWit Media, documenting the journey of a college sports photographer balancing academics and professional growth."
  );

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const query = `*[_type == "post"]{ title, slug, mainImage, publishedAt }`;
    client.fetch(query).then((data) => {
      setPosts(data);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="blog-container">
        {" "}
        <h1>Loading posts...</h1>{" "}
      </div>
    );
  }

  return (
    <div className="blog-container">
      <header className="blog-header">
        {" "}
        <h1>The TjWit Media Blog</h1>{" "}
      </header>
      <div className="posts-grid">
        {posts.map((post) => (
          <Link
            to={`/blog/${post.slug.current}`}
            key={post.slug.current}
            className="post-card"
          >
            {post.mainImage && (
              <img
                src={urlFor(post.mainImage).width(400).url()}
                alt={post.title}
                className="post-card-image"
              />
            )}
            <div className="post-card-content">
              <h2>{post.title}</h2>
              <p>
                {" "}
                Published on: {new Date(
                  post.publishedAt
                ).toLocaleDateString()}{" "}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
export default BlogPage;
